<template>
  <div class="services-page">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1></h1>
         
        </div>
      </div>
    </section>

    <section class="services">
      <div class="container">
        <div class="services-grid">
          <div class="service-card">
            <div class="card-media">
              <div class="card-image">
                <img src="@/assets/images/service_gov_advisory.png" alt="AI Strategy">
              </div>
              <h2>Government Advisory: Building National AI Competitiveness</h2>
            </div>
            <div class="card-text">
              <ul>
                <li>
                  <div class="li-content">
                    <div class="li-body">
                      <span class="li-title"><strong>National AI Strategy and Policy Development:</strong>
                      Designing AI development roadmaps, industrial policies, and ethical frameworks tailored to national contexts.</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="li-content">
                    <div class="li-body">
                      <span class="li-title"><strong>Legal and Regulatory Framework Development:</strong>
                      Advising on legislation and compliance systems for data security, algorithm governance, and market access.</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="service-card">
            <div class="card-media">
              <div class="card-image">
                <img src="@/assets/images/service_industry_solutions.png" alt="Global Strategy">
              </div>
              <h2>Industry Solutions: Driving Intelligent Transformation</h2>
            </div>
            <div class="card-text">
              <ul>
                <li>
                  <div class="li-content">
                  
                    <div class="li-body">
                      <span class="li-title"><strong>Sector-Specific AI Design and Consulting:</strong>
                      Deep-diving into sectors like agriculture, mining, and manufacturing to diagnose challenges and design feasible AI-enabled solutions.</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="li-content">
                    
                    <div class="li-body">
                      <span class="li-title"><strong>Technology Selection and Implementation Planning:</strong>
                      Recommending optimal technologies and implementation pathways based on the global technology landscape, reducing investment risk.</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="service-card">
            <div class="card-media">
              <div class="card-image">
                <img src="@/assets/images/service_implementation.png" alt="Risk Governance">
              </div>
              <h2>End-to-End Implementation: Turning Strategy into Reality</h2>
            </div>
            <div class="card-text">
              <ul>
                <li>
                  <div class="li-content">
                  
                    <div class="li-body">
                      <span class="li-title"><strong>Full-Cycle Support:</strong> 
                      project management, technical guidance, and support for operation from proof-of-concept through pilot projects to full-scale deployment.</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="li-content">
                    
                    <div class="li-body">
                      <span class="li-title"><strong>Capital and Investment Connection:</strong> 
                      Connecting promising AI projects with our global network of investors, including venture capital, industry funds, and development banks.</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="li-content">
                    
                    <div class="li-body">
                      <span class="li-title"><strong>Ecosystem and Partnership Building:</strong> 
                      Introducing key partners across the value chain, such as technology vendors, system integrators, and hardware providers as needed.</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="li-content">
                    
                    <div class="li-body">
                      <span class="li-title"><strong>Regulatory and Certification Support:</strong> 
                      Facilitating communication with local and international regulatory bodies, standards organizations, and certification agencies to ensure compliance and market access.</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          
        </div>
      </div>
    </section>

    <section class="featured-engagement">
      <div class="container">
        <div class="engagement-content">
          <h2>Our Engagement Models</h2>
          <h3>Strategic Consulting Projects 
           
          </h3>
          <h3>Long-Term Strategic Support 
            
          </h3>
          <h3>High-End Customized Engagements 
            
          </h3>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicesPage'
}
</script>

<style scoped>
  
.hero {
  background-image: url('../assets/新what we do.jpg');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0;
  text-align: center;
  position: relative;
  width: 100%;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
}

.services {
  background-color: black;
  color: white;
  padding: 6rem 0;
  width: 100%;
  
}

.services .container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
}

.services-grid {
  display: flex;
  flex-direction: column;
  gap: 80px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  background-color: #111;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: stretch;
  min-height: 300px;
}

.service-card:nth-child(even) {
  flex-direction: row-reverse;
}

.card-media {
  flex: 0 0 35%; /* Reduced from 45% */
  display: flex;
  flex-direction: column;
  /* justify-content: center; */ /* Let it fill */
}

.card-text {
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-left: 1px solid #333;
}

.service-card:nth-child(even) .card-text {
  border-left: none;
  border-right: 1px solid #333;
}

.service-card h2 {
  text-align: left;
  padding: 1.5rem;
  margin: 0;
  font-size: 1.3rem; /* Reduced from 1.5rem */
  color: var(--primary-color);
  background-color: #1a1a1a; /* Slight contrast for title area if needed, or transparent */
  flex-grow: 1; /* Fill remaining space below image */
  display: flex;
  align-items: center;
}
.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}

.card-image {
  width: 100%;
  height: 250px; /* Taller image for this layout */
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.service-card:hover .card-image img {
  transform: scale(1.05);
}

.card-content ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

/* New List Styles */
.card-text ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.li-content {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.li-num {
  font-size: 1.4rem; /* Increased from 1.2rem */
  font-weight: bold;
  color: var(--primary-color); /* Or accent color */
  min-width: 1.5rem;
}

.li-body {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: left;
  gap: 0.5rem;
}

.li-title {
  font-size: 1.2rem; /* Increased from 1rem */
  color: #eee;
  font-weight: 500;
  width: 100%; 
  text-align: left;/* Ensure it takes full width so desc breaks to new line */
}

.li-desc {
  font-size: 0.95rem;
  color: #aaa;
  margin-top: 0.25rem;
  width: 100%;
  line-height: 1.4;
  text-align: left;
}

/* Tooltip styles */
.tooltip {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
  margin-top: 2px; /* Align with text */
}

.tooltip-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.tooltip .tooltip-text {
  visibility: hidden;
  width: 200px;
  background-color: rgba(0, 0, 0, 0.9);
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 10;
  bottom: 130%;
  right: -10px; /* Align right edge near the icon */
  left: auto;
  transform: none;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 0.85rem;
  line-height: 1.4;
  box-shadow: 0 2px 10px rgba(255, 255, 255, 0.1);
  border: 1px solid #333;
}

.tooltip .tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 12px; /* Align arrow with icon */
  left: auto;
  margin-left: 0;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.9) transparent transparent transparent;
}

.tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.featured-engagement{
    width:100%;
    background-color: #d4eff3;
    height:250px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    
   }
  .featured-engagement h2{
    font-size: 30px;
    line-height: 2;
  }
  .featured-engagement h3{
    font-size: 17px;
    line-height: 2;
  }
.engagement-content{
  text-align: center;
  line-height: 2;
}
@media (max-width: 768px) {
  .service-card,
  .service-card:nth-child(even) {
    flex-direction: column;
    height: auto;
  }
  
  .card-media, .card-text {
    flex: auto;
    width: 100%;
    border: none !important;
  }

  .card-image {
    height: 200px;
  }
  
  .hero h1, .featured-engagement h2 {

  }
  
}
</style>